import { cn } from '@/lib/helpers/utils';
import { ChevronDown } from 'lucide-react';
import React from 'react';

interface AccordionForceMountItemProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

export function AccordionForceMountItem({
  title,
  children,
  isOpen,
  onToggle,
  className,
  ...props
}: AccordionForceMountItemProps) {
  return (
    <div className={cn('overflow-hidden', className)} {...props}>
      <button className="w-full flex items-center justify-between text-left" onClick={onToggle}>
        {title}
        <ChevronDown
          className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      <div
        className={`overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out ${
          isOpen ? 'opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {children}
      </div>
    </div>
  );
}

interface AccordionForceMountProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: 'single' | 'multiple';
}

export function AccordionForceMount({ type = 'single', className, children, ...props }: AccordionForceMountProps) {
  return (
    <div className={cn('', className)} {...props}>
      {children}
    </div>
  );
}

/**
 * Wrapper from design system component.
 */

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@group-gti/inferno-design-system-react';
